import { api } from '../configs/apiConfig';

class AnnouncementService {
    async getActiveAnnouncements() {
        const response = await api.get('/announcement/active');
        return response.data;
    }

    async getAnnouncementsByUser(userId) {
        const response = await api.get(`/announcement/user/${userId}`);
        return response.data;
    }

    async getAnnouncement(id) {
        const response = await api.get(`/announcement/${id}`);
        return response.data;
    }

    async createAnnouncement(announcement) {
        if (!announcement.createdById) {
            throw new Error('User ID is required to create an announcement');
        }
        const response = await api.post('/announcement', announcement);
        return response.data;
    }

    async updateAnnouncement(id, announcement) {
        const response = await api.put(`/announcement/${id}`, announcement);
        return response.data;
    }

    async deleteAnnouncement(id) {
        await api.delete(`/announcement/${id}`);
    }
}

export default new AnnouncementService(); 